<script>
import { onMount } from 'svelte';


import Loading from 'components/elements/Loading.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';



import SvelteSeo from 'svelte-seo';


onMount(() => {
	navigateTo('/forms');
});

</script>


<style>
	

</style>



<SvelteSeo
	title='Contact | AHG Forms'
	description='Contact!'
/>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				My Submitted Forms
			</p>

		</div>

	</div>
	
</section>



<section class="section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-9-desktop is-10-tablet is-12-mobile">

				<MsgCard msg_show={true} msg_text={'You have not submitted any forms yet!'} msg_type={'error'} msg_forever={true} />

			</div>

		</div>

	</div>

</section>

<!-- email: donotreply@atlantichockeygroup.com -->

